import { render } from "./FileUpload.vue?vue&type=template&id=d13f7dfa&scoped=true"
import script from "./FileUpload.vue?vue&type=script&lang=js"
export * from "./FileUpload.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-d13f7dfa"

export default script